import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { dateFormatMMMDDYYYY } from "../../utils/date.util";
import '../modals/modals.css';
import SmeStatusBadges from "../common/sme-badge";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { Typography, Unstable_Grid2, Dialog, DialogContent, DialogTitle, Button } from '@mui/material';
import { Icon } from '@iconify/react';
import IconButton from '@mui/material/IconButton';
import { DASBHBOARD_BLUE_COLOR, DocumentTypeLabel, FamilyDetailAge, LeadStatus, LeadStatusLabel, PolicyType, PolicyTypeLabel } from "./dashboard.constants";
import { LeadApiService, toBase64 } from "./lead-api.service";
import { UploadedFileType, DynamicFileUploader } from "../common/FileUploder";
import useSnackBars from "../common/snackbar/SmeSnackbar";
import { encryptData } from "../../utils/index";
import axios from "axios";
export const WebloaderTS = (status) => {
    var _a, _b, _c, _d;
    if (status === "show") {
        (_b = (_a = document.querySelector(".WebLoader")) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove("d-none");
    }
    else {
        (_d = (_c = document.querySelector(".WebLoader")) === null || _c === void 0 ? void 0 : _c.classList) === null || _d === void 0 ? void 0 : _d.add("d-none");
    }
};
export function getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
const boldText = {
    fontWeight: 500,
    wordWrap: "break-word"
};
const labelText = {
    fontWeight: 400,
    color: '#808080'
};
const LeadStatusBadge = [
    {
        key: LeadStatus.DRAFT_SAVED,
        label: LeadStatusLabel[LeadStatus.DRAFT_SAVED],
        color: '#FFCCCC'
    },
    {
        color: '#FFDECC',
        key: LeadStatus.LEAD_GENERATED,
        label: LeadStatusLabel[LeadStatus.LEAD_GENERATED]
    },
    {
        color: '#CCDAFF',
        key: LeadStatus.PAYMENT_DONE,
        label: LeadStatusLabel[LeadStatus.PAYMENT_DONE]
    },
    {
        color: '#CCF6FF',
        key: LeadStatus.PAYMENT_INITIATED,
        label: LeadStatusLabel[LeadStatus.PAYMENT_INITIATED]
    },
    {
        color: '#FFF7CC',
        key: LeadStatus.QUOTE_DOWNLOADED,
        label: LeadStatusLabel[LeadStatus.QUOTE_DOWNLOADED]
    },
    {
        color: '#D6FFCC',
        key: LeadStatus.QUOTE_SHARED,
        label: LeadStatusLabel[LeadStatus.QUOTE_SHARED]
    },
    {
        key: LeadStatus.QUOTE_FAILED_ICR,
        label: LeadStatusLabel[LeadStatus.QUOTE_FAILED_ICR],
        color: '#FFCCCC'
    },
];
const FamilyDetailAgeLabel = {
    [FamilyDetailAge.emp]: 'Emp (36-65 Age)',
    [FamilyDetailAge.emp18]: 'Emp (18-35 Age)',
    [FamilyDetailAge.emp36]: 'Emp (36-45 Age)',
    [FamilyDetailAge.emp46]: 'Emp (46-55 Age)',
    [FamilyDetailAge.emp56]: 'Emp (56-65 Age)',
    [FamilyDetailAge.child]: 'Child',
    [FamilyDetailAge.inlaws]: 'In Laws',
    [FamilyDetailAge.mother]: 'Mother',
    [FamilyDetailAge.spouse]: 'Spouse',
    [FamilyDetailAge.parents]: 'Parents'
};
const DataLabel = ({ label, value }) => {
    return _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "caption", style: labelText, children: label }), _jsx(Typography, { variant: "body2", style: { fontWeight: 500, wordWrap: "break-word" }, children: value })] });
};
const FamilyDetailModal = (props) => {
    const updatedFamilyData = useMemo(() => {
        const data = { ...props.detail };
        // if (data && data[FamilyDetailAge.emp] && data[FamilyDetailAge.emp18]) {
        //     data[FamilyDetailAge.emp18] = data[FamilyDetailAge.emp18] + data[FamilyDetailAge.emp];
        // } else if (data && !data[FamilyDetailAge.emp18] && data[FamilyDetailAge.emp]) {
        //     data[FamilyDetailAge.emp18] = data[FamilyDetailAge.emp];
        // }
        // delete data[FamilyDetailAge.emp];
        return data;
    }, []);
    console.log(updatedFamilyData, 'updated data');
    return _jsxs(Dialog, { PaperProps: {
            sx: { boxShadow: '0px 4px 14px 4px #0000001A' }
        }, open: true, fullWidth: true, onClose: () => {
            props.toggle();
        }, children: [_jsx(DialogTitle, { sx: { borderBottom: (theme) => { var _a; return `1px solid ${(_a = theme.palette.grey[200]) !== null && _a !== void 0 ? _a : 'grey'}`; } }, children: _jsxs(Unstable_Grid2, { container: true, children: [_jsx(Unstable_Grid2, { xs: 11, children: _jsx(Typography, { variant: "subtitle1", style: { ...boldText }, children: "Sum Insured & Demographics" }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', justifyContent: 'end' }, xs: 1, children: _jsx(Icon, { icon: 'mdi:close', style: { cursor: "pointer" }, onClick: props.toggle }) })] }) }), _jsxs(DialogContent, { children: [_jsxs(Unstable_Grid2, { marginTop: '10px', spacing: 2, container: true, children: [_jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 3, children: _jsx(DataLabel, { label: 'Sum Insured', value: props.sumInsured }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 3, children: _jsx(DataLabel, { label: 'Plan Type', value: props.planType }) })] }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: '10px', margin: '10px 0' }, children: [_jsx(Typography, { variant: "subtitle2", children: "Insured Details" }), _jsx("div", { style: { flexGrow: '1' }, children: _jsx("hr", {}) })] }), _jsx(Unstable_Grid2, { container: true, spacing: 3, children: Object.keys(updatedFamilyData !== null && updatedFamilyData !== void 0 ? updatedFamilyData : {}).map(key => {
                            var _a;
                            const val = updatedFamilyData[key];
                            return _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 4, children: _jsx(DataLabel, { label: (_a = FamilyDetailAgeLabel[key]) !== null && _a !== void 0 ? _a : '', value: val }) }, key);
                        }) })] })] });
};
const QuoteGeneratedUI = (props) => {
    var _a, _b, _c;
    return _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, xs: 6, sm: 6, md: 'auto', children: _jsx(DataLabel, { label: 'Quote Generated', value: _jsx(_Fragment, { children: _jsxs("div", { children: [_jsx("span", { style: { fontWeight: 100 }, children: "Customized" }), " : ", !!((_a = props === null || props === void 0 ? void 0 : props.calculated) === null || _a === void 0 ? void 0 : _a.customizedPremium) && _jsxs("span", { children: ["\u20B9", (_c = ((_b = props === null || props === void 0 ? void 0 : props.calculated) === null || _b === void 0 ? void 0 : _b.customizedPremium) + '/yr') !== null && _c !== void 0 ? _c : '-'] })] }) }) }) });
};
const SumInsuredUI = (props) => {
    const [familyDetailsToBeShow, setFamilyDetailsToBeShow] = useState(null);
    const onEyeClick = (sum) => {
        const details = props.familyDetails[sum];
        setFamilyDetailsToBeShow({ details, sum });
    };
    const closeFamilyDetailModal = () => {
        setFamilyDetailsToBeShow(null);
    };
    return _jsxs(_Fragment, { children: [_jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, xs: 'auto', children: _jsx(DataLabel, { label: 'Sum Insured', value: _jsx(_Fragment, { children: props.sum.map((sum, index) => {
                            var _a;
                            const showEye = Object.keys((_a = props === null || props === void 0 ? void 0 : props.familyDetails) !== null && _a !== void 0 ? _a : {}).includes(sum);
                            return _jsxs("div", { style: { display: 'flex' }, children: [_jsxs("span", { style: { fontWeight: 100, color: '#000000', display: 'flex' }, children: ["Sum Insured ", index + 1, " "] }), "\u00A0:\u00A0", _jsxs("span", { style: { display: 'flex', alignItems: 'center' }, children: [_jsxs("span", { children: [" ", sum, " "] }), " \u00A0", showEye && _jsx("span", { style: { display: 'flex', alignItems: 'center' }, children: _jsx(Icon, { icon: "mdi:eye-outline", onClick: () => onEyeClick(sum), cursor: 'pointer', color: DASBHBOARD_BLUE_COLOR, height: '20px', width: '20px' }) })] })] }, sum);
                        }) }) }) }), familyDetailsToBeShow && _jsx(FamilyDetailModal, { detail: familyDetailsToBeShow.details, planType: props.planType, sumInsured: familyDetailsToBeShow.sum, toggle: closeFamilyDetailModal })] });
};
const DocumentList = (props) => {
    const [data, setDocList] = useState(null);
    const { addAlert } = useSnackBars() || {};
    const [uploadDocuments, setUploadDocuments] = useState(null);
    const voAuthToken = getCookie('vo-auth-token');
    const agent = getCookie('vo-login-id');
    const toggleUploadDocuments = (data) => {
        if (data === null || data === void 0 ? void 0 : data.category) {
            setUploadDocuments(data);
        }
        else {
            setUploadDocuments(null);
        }
    };
    const fetchDocument = (leadID) => {
        WebloaderTS("show");
        const pro = LeadApiService.getDocumentList(leadID, voAuthToken, agent);
        pro.then(res => {
            var _a, _b, _c;
            if ((_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c.length) {
                setDocList(res.data.data.documents);
            }
            else {
                setDocList(null);
            }
            WebloaderTS();
        }).catch(error => {
            var _a, _b, _c, _d;
            WebloaderTS();
            if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500 && ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message)) {
                addAlert(error.response.data.message);
            }
            if ((error === null || error === void 0 ? void 0 : error.response) && ((_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.status) === 401) {
                console.error('Bad Request:', error.response.data);
            }
        });
    };
    useEffect(() => {
        fetchDocument(props.leadId);
    }, [props.leadId]);
    const uploadFileApi = (req) => {
        WebloaderTS("show");
        const pro = LeadApiService.uploadCategoryDocument(req, props.leadId, props.companyId, voAuthToken, agent);
        pro.then(res => {
            var _a, _b, _c;
            console.log('Upload finished ', res);
            if ((req === null || req === void 0 ? void 0 : req.category) && ((_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.marketRenewalDoc[req.category]) === null || _c === void 0 ? void 0 : _c.isUploaded)) {
                addAlert('Document uploaded successfully');
            }
            else {
                addAlert('Failed to upload document. Please try again');
            }
            WebloaderTS();
        }).catch(error => {
            WebloaderTS();
            // if (error.response && error.response.status === 401) {
            console.error('Bad Request:', error);
            addAlert('Failed to upload document. Please try again');
            // }
        }).finally(() => {
            console.log('Upload finished finally');
            toggleUploadDocuments();
            fetchDocument(props.leadId);
        });
    };
    const onUpoad = (files) => {
        if (files.length > 0) {
            const singleFile = files[0];
            console.log('Upload', singleFile);
            toBase64(singleFile).then((file) => {
                var _a;
                if (uploadDocuments === null || uploadDocuments === void 0 ? void 0 : uploadDocuments.category) {
                    const f = file.split(',')[1] ? encryptData(file.split(',')[1]) : '';
                    const req = { category: (_a = uploadDocuments === null || uploadDocuments === void 0 ? void 0 : uploadDocuments.category) !== null && _a !== void 0 ? _a : '', displayName: singleFile.name, documentType: UploadedFileType[singleFile.type], documentImage: f };
                    uploadFileApi(req);
                }
            });
        }
    };
    const onDownloadFiles = async (file, name) => {
        var _a, _b;
        if (file) {
            try {
                let url = file;
                if (!url.startsWith('http')) {
                    url = `https://${url}`;
                }
                const response = await axios.get(url, {
                    responseType: "blob",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(new Blob([response.data]));
                link.setAttribute("download", name !== null && name !== void 0 ? name : '');
                // deepcode ignore DOMXSS: ASK TO Senior
                document.body.appendChild(link);
                link.click();
                const message = {
                    type: (name === null || name === void 0 ? void 0 : name.endsWith('.pdf')) ? 'pdf' : 'excel',
                    data: {
                        base64: response.data,
                        fileName: name || "downloadedFile",
                    },
                };
                const jsonString = JSON.stringify(message);
                // @ts-ignore
                (_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(jsonString);
            }
            catch (e) {
                console.log(e.response, e);
                if (((_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.status) === 500) {
                    addAlert('Internal Server Error (500)');
                }
            }
        }
    };
    const deleteFile = (document) => {
        WebloaderTS("show");
        if (!document.category || !document.documentId) {
            return;
        }
        const pro = LeadApiService.deleteCategoryDocument(document.category, props.leadId, document.documentId, voAuthToken, agent);
        pro.then(res => {
            WebloaderTS();
            addAlert('Document deleted successfully');
        }).catch(error => {
            var _a;
            WebloaderTS();
            if ((error === null || error === void 0 ? void 0 : error.response) && ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                console.error('Bad Request:', error);
                addAlert('Failed to delete document. Please try again');
            }
        }).finally(() => {
            console.log('delete finished');
            toggleUploadDocuments();
            fetchDocument(props.leadId);
        });
    };
    return _jsx(_Fragment, { children: _jsxs(Dialog, { PaperProps: {
                sx: { boxShadow: '0px 4px 14px 4px #0000001A' }
            }, open: true, fullWidth: true, onClose: () => {
                props.toggle(false);
            }, children: [_jsx(DialogTitle, { sx: { borderBottom: (theme) => { var _a; return `1px solid ${(_a = theme.palette.grey[200]) !== null && _a !== void 0 ? _a : 'grey'}`; } }, children: _jsxs(Unstable_Grid2, { container: true, children: [_jsx(Unstable_Grid2, { xs: 11, children: _jsx(Typography, { variant: "subtitle1", fontWeight: 500, children: "Uploaded Files" }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', justifyContent: 'end', alignItems: 'center' }, xs: 1, children: _jsx(Icon, { icon: 'mdi:close', style: { cursor: "pointer" }, onClick: () => props.toggle(false) }) })] }) }), _jsxs(DialogContent, { sx: { padding: '16px', marginTop: '16px' }, children: [!!(data === null || data === void 0 ? void 0 : data.length) && data.map(document => {
                            return _jsxs(_Fragment, { children: [_jsxs(Unstable_Grid2, { container: true, direction: 'row', marginBottom: '5px', alignItems: 'center', justifyContent: 'space-between', children: [_jsx(Typography, { variant: "caption", alignItems: 'center', noWrap: true, fontSize: '11px', fontWeight: 400, color: '#808080', children: DocumentTypeLabel[document.category] }), !document.documentId && _jsx(Button, { variant: "text", size: "small", sx: { fontSize: '12px', fontWeight: '600', color: '#0d6efd' }, onClick: () => toggleUploadDocuments(document), children: "+ Add File" })] }), !!(document === null || document === void 0 ? void 0 : document.documentId) && _jsx(Card, { sx: { margin: '0px 0px 8px 0px ', border: '1px solid #E6E6E6', background: '#FBFDFF', borderRadius: '8px' }, children: _jsx(CardContent, { children: _jsxs(_Fragment, { children: [" ", _jsxs(Unstable_Grid2, { container: true, spacing: 4, style: { display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Unstable_Grid2, { xs: 8, sm: 8, md: 10, children: _jsx(Typography, { variant: "body2", noWrap: true, fontSize: '14px', fontWeight: 600, color: '#000000', children: document.displayName }) }), _jsx(Unstable_Grid2, { xs: 4, sm: 4, md: 2, sx: { display: 'flex', justifyContent: 'end', gap: '16px' }, children: _jsx(Unstable_Grid2, { display: 'flex', alignItems: 'center', md: 4, children: _jsx(Icon, { onClick: () => onDownloadFiles(document.presignedUrl, document.documentType === 'application/pdf' ? 'docuemnt.pdf' : 'dump.xlsx'), fontSize: '16px', icon: 'mdi:tray-download', style: { cursor: "pointer", color: '#0d6efd' } }) }) })] }), _jsx(Typography, { variant: "caption", noWrap: true, fontSize: '11px', fontWeight: 400, color: '#808080', children: document.documentType })] }) }) })] });
                        }), (uploadDocuments === null || uploadDocuments === void 0 ? void 0 : uploadDocuments.category) && _jsxs(Dialog, { PaperProps: {
                                sx: { boxShadow: '0px 4px 14px 4px #0000001A' }
                            }, open: true, fullWidth: true, onClose: () => {
                                toggleUploadDocuments();
                            }, children: [_jsx(DialogTitle, { sx: { borderBottom: (theme) => { var _a; return `1px solid ${(_a = theme.palette.grey[200]) !== null && _a !== void 0 ? _a : 'grey'}`; } }, children: _jsxs(Unstable_Grid2, { container: true, children: [_jsx(Unstable_Grid2, { xs: 11, children: _jsxs(Typography, { variant: "subtitle1", fontWeight: 500, children: ["Upload ", DocumentTypeLabel[uploadDocuments.category]] }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', justifyContent: 'end', alignItems: 'center' }, xs: 1, children: _jsx(Icon, { icon: 'mdi:close', style: { cursor: "pointer" }, onClick: () => toggleUploadDocuments() }) })] }) }), _jsx(DialogContent, { sx: { padding: '18px', marginTop: '18px' }, children: _jsx(DynamicFileUploader, { typeAllowed: {
                                            "application/pdf": [".pdf"],
                                            "application/msexcel": [".xls", ".xlsx"],
                                            "text/csv": [".csv"]
                                        }, maxFiles: 1, onUpload: onUpoad, maxFileSizeInBytes: 7340032, onCloce: toggleUploadDocuments }) })] })] })] }) });
};
const LeadCard = (props) => {
    const dateFormat = dateFormatMMMDDYYYY(props.createdAt);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showDocumentList, setShowDocumentLIst] = useState(false);
    const toggleDocumentList = (data) => {
        setShowDocumentLIst(data);
    };
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return _jsxs(Card, { sx: { margin: '10px 0', width: '100%', borderRadius: '14px', boxShadow: '0px 2px 20px 0px #0000000D', border: '1px solid #E6E6E6' }, children: [_jsx(CardHeader, { sx: { borderBottom: (theme) => { var _a; return `1px solid ${(_a = theme.palette.grey[200]) !== null && _a !== void 0 ? _a : 'grey'}`; }, padding: '16px 24px' }, title: _jsxs("div", { style: { display: 'flex', justifyContent: 'space-between' }, children: [_jsxs("div", { children: [_jsx(Typography, { variant: "h6", className: "h6", fontWeight: '600', children: props.corporateName }), _jsx(Typography, { variant: "subtitle2", className: "subtitle2 text-muted", children: props.userType })] }), _jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [_jsx("div", { style: { marginRight: '10px' }, children: _jsx(SmeStatusBadges, { badges: LeadStatusBadge, selectedKey: props.leadStatus }) }), props.policyType === PolicyType.MARKET_RENEWAL && _jsx(IconButton, { onClick: () => toggleDocumentList(true), sx: {
                                        '&:focus': {
                                            outline: 'none'
                                        }
                                    }, "aria-label": "more", children: _jsx(Icon, { icon: "mdi:cloud-upload-outline" }) })] })] }) }), _jsx(CardContent, { sx: { p: '16px', '&:last-child': { pb: '16px' } }, children: _jsxs(Unstable_Grid2, { container: true, spacing: 2, direction: 'row', sx: { position: 'relative' }, children: [_jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 2, children: _jsx(DataLabel, { label: 'Contact Person Name', value: props.contactName }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 2, children: _jsx(DataLabel, { label: 'Contact Person Phone', value: props.contactNumber }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 3, children: _jsx(DataLabel, { label: 'Contact Person email', value: props.emailId }) }), _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 2, children: _jsx(DataLabel, { label: 'Quote Type', value: PolicyTypeLabel[props === null || props === void 0 ? void 0 : props.policyType] }) }), _jsx(QuoteGeneratedUI, { calculated: props.calculatedOutput, quoteDownloaded: props.quoteGenerated }), _jsx(SumInsuredUI, { sum: props.sumInsured, familyDetails: props.familyDetails, planType: props.planType }), _jsx(Unstable_Grid2, { sx: { display: 'flex', flexDirection: 'column' }, sm: 6, xs: 6, md: 2, children: _jsx(DataLabel, { label: 'Policy Type', value: props.planType }) }), _jsx(Typography, { variant: "subtitle2", className: "d-flex position-absolute ", style: { bottom: '8px', right: '8px', fontWeight: '500', color: '#A3A3A3' }, children: dateFormat })] }) }), showDocumentList && _jsx(DocumentList, { companyId: props.companyId, leadId: props.leadId, toggle: toggleDocumentList })] });
};
export default LeadCard;
